<form [formGroup]="Form">
    <div class="form-row">
        <div class="form-group col-lg-12">
            <textarea rows="5" class="form-control" formControlName="coqu_tx_description"
                placeholder="Ingrese su pregunta"></textarea>
        </div>
    </div>
    
    <div class="form-row">
        <div class="form-group col-lg-12 center">
            <mat-radio-group  name="coqu_in_quiz_type" formControlName="coqu_in_quiz_type"  [(ngModel)]="default_coqu_in_quiz_type">
                <ng-container *ngFor="let item of parameters">
                    <mat-radio-button *ngIf="item.sys_in_group == 1400" [value]="item.sys_in_parameter" (change)="Change_coqu_in_quiz_type($event)">
                        {{item.sys_vc_description}} &nbsp;&nbsp;&nbsp;</mat-radio-button>
                </ng-container>
            </mat-radio-group>
        </div>
    </div>
    <br>
 
    <button class="btn btn-badminton btn-sm pull-right" (click)="SaveQuizQuestion()">Guardar</button>
</form>


